import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { catalogOverviewOverride } from './CatalogOverviewOverride';
import {
  dependsOnComponentsCardOverride,
  dependsOnResourcesCardOverride,
  hasSubcomponentsCardOverride,
  hasSubdomainsCardOverride,
  hasResourcesCardOverride,
  hasSystemsCardOverride,
} from './DependencyCardOverrides';

export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    catalogOverviewOverride,
    dependsOnComponentsCardOverride,
    dependsOnResourcesCardOverride,
    hasSubcomponentsCardOverride,
    hasSubdomainsCardOverride,
    hasResourcesCardOverride,
    hasSystemsCardOverride,
  ],
});
